module.exports = __webpack_public_path__ + "static/media/wallDrawing65.810114ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPageContent/images/wallDrawing65.png
// module id = 413
// module chunks = 0